export interface AgendaEvent {
  id: string;
  brandId: string;
  fitterId: string;
  comment: string;
  type: AgendaEventType;
  title?: string;
  startTime?: string | Date;
  endTime: string | Date;
  timezone: string;
  resources: AgendaEventFitterResource[];
  interventionVehicle?: AgendaEventFitterResource;
  creationData?: AgendaEventCreationData;
  createDate?: Date;
  updateDate?: Date;
  allDay?: boolean;
  locations?: AgendaEventLocation[];
  additionalData?: any;
}

export interface RecurrentAgendaEvent extends AgendaEvent {
  recurrent: {
    startDate: string | Date;
    endDate: string | Date;
    freq: 'day' | 'week';
    every: number;
    daysOfWeek?: number[]; // Sunday as 0 and Saturday as 6 (only for freq=week)
    daysDeletes?: { startDate: string | Date; endDate: string | Date }[];
  };
}
export interface RecurrentInstanceAgendaEvent extends AgendaEvent {
  generatedFrom: string;
}

export interface AgendaEventCreationData {
  code: string;
  email: string;
  origin: AgendaCreationDataOrigin;
}

export type AgendaCreationDataOrigin =
  | 'AGENDA'
  | 'B2B'
  | 'B2C'
  | 'API'
  | 'PARTNERS_SYNC';

export interface AgendaEventFitterResource {
  name: string;
  id?: string;
}

export type AgendaEventType =
  | 'GENERIC'
  | 'SPECIAL_CLOSING'
  | 'SPECIAL_OPENING'
  | 'HOLYDAY'
  | 'TECH_LEAVE'
  | 'INTERVENTION_VEHICLE_LEAVE'
  | 'RV_LEAVE';

export enum AgendaEventLocationEnum {
  center = 'center',
  outside = 'outside',
}

export type AgendaEventLocation = `${AgendaEventLocationEnum}`;
